'use client';

import Image from 'next/image';
import AsurionLogo from 'public/images/asurion-logo.svg';
import styled from 'styled-components';

const StyledFooterLogoContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1rem;
`;

type FooterLogoProps = {
  logoSrc?: string;
  altText?: string;
  height?: number;
  width?: number;
  copyrightText?: string;
  isTwoStep?: boolean;
  className?: string;
};

export const FooterLogo = ({
  logoSrc,
  altText = '',
  height,
  width,
  copyrightText,
  isTwoStep,
  className,
}: FooterLogoProps) => (
  <StyledFooterLogoContainer>
    <div>
      {logoSrc ? (
        <Image
          src={logoSrc}
          alt={altText}
          height={height ?? 34}
          width={width ?? 128}
          className={className}
        />
      ) : (
        <Image
          src={AsurionLogo}
          alt="Asurion logo"
          width={128}
          className={className}
        />
      )}
    </div>

    {!isTwoStep
      ? copyrightText
        ? copyrightText
        : `© Asurion 1992-${new Date().getFullYear()}. All Rights Reserved.`
      : null}
  </StyledFooterLogoContainer>
);
